import React, { useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Toast from 'react-bootstrap/Toast'
import ToastContainer from 'react-bootstrap/ToastContainer'
import API from '../axios'

const HOME_URL = process.env?.REACT_APP_WEBSITE_URL || ''

const SOCIAL_LINKS = [
    { href: 'https://www.facebook.com/MSP-La-Pyramide-114713840178405/', src: '../../assets/images/facebook.png', alt: 'Facebook' },
    { href: 'https://www.instagram.com/msplapyramide/', src: '../../assets/images/instagram.png', alt: 'Instagram' },
    { href: 'https://twitter.com/MSPLaPyramide', src: '../../assets/images/twitter.png', alt: 'Twitter' },
    { href: 'https://www.youtube.com/watch?v=u98QEyA_o6Q&feature=youtu.be', src: '../../assets/images/youtube.png', alt: 'YouTube' },
    { href: 'https://www.linkedin.com/company/msp-la-pyramide', src: '../../assets/images/linkedin.png', alt: 'LinkedIn' }
]

const LoadingState = () => (
    <Row>
        <Col sm={12} className="info-contact">
            <Spinner animation="border" role="status" variant="success" />
            <p className="text-info-contact">Traitement de votre demande...</p>
        </Col>
    </Row>
)

const SuccessState = () => (
    <Row>
        <Col sm={12} className="info-contact">
            <h1 className="title-contact">Abonnement annulé</h1>
            <p className="text-info-contact">
                Votre désinscription de la newsletter a bien été prise en compte.
            </p>
            <p className="text-info-contact">
                Nous sommes désolés de vous voir partir. N'hésitez pas à vous réabonner à tout moment depuis notre site.
            </p>
            <p className="text-info-contact">
                À bientôt,
                <br />
                L'équipe médicale de la MSP La Pyramide
            </p>
        </Col>
    </Row>
)

const ErrorState = ({ message }) => {
    const [showToast, setShowToast] = useState(true)

    useEffect(() => {
        const timer = setTimeout(() => setShowToast(false), 5000)
        return () => clearTimeout(timer)
    }, [])

    return (
        <>
            <ToastContainer position="top-end" className="p-3" style={{ position: 'fixed', zIndex: 9999 }}>
                <Toast show={showToast} onClose={() => setShowToast(false)} bg="warning" delay={5000} autohide>
                    <Toast.Header closeButton>
                        <strong className="me-auto">Attention</strong>
                    </Toast.Header>
                    <Toast.Body className="text-dark">{message}</Toast.Body>
                </Toast>
            </ToastContainer>
            <Row>
                <Col sm={12} className="info-contact">
                    <p className="text-info-contact">{message}</p>
                </Col>
            </Row>
            <Row>
                <Col sm={12} className="info-contact">
                    <a href={HOME_URL} className="bt-green-def">Retour à l'accueil</a>
                </Col>
            </Row>
        </>
    )
}

const statusComponents = {
    loading: LoadingState,
    success: SuccessState,
    error: ErrorState
}

const CancelSubscription = ({ location }) => {
    const [status, setStatus] = useState('loading')
    const [errorMessage, setErrorMessage] = useState('')

    useEffect(() => {
        const email = new URLSearchParams(location.search).get('email')

        if (!email) {
            setStatus('error')
            setErrorMessage("L'adresse e-mail est manquante. Veuillez utiliser le lien fourni dans la newsletter.")
            return
        }

        const handleSuccess = (response) => {
            if (response.status === 200) {
                setStatus('success')
            } else {
                setStatus('error')
                setErrorMessage("Une erreur est survenue lors de l'annulation de votre abonnement.")
            }
        }

        const handleError = () => {
            setStatus('error')
            setErrorMessage("Une erreur est survenue lors de l'annulation de votre abonnement. Veuillez réessayer plus tard.")
        }

        API.get('post/cancel/subscription?email=' + encodeURIComponent(email))
            .then(handleSuccess)
            .catch(handleError)
    }, [location.search])

    const StatusComponent = statusComponents[status]

    return (
        <Container className="container-main-contact">
            <Row>
                <Col sm={12} className="text-center">
                    <a href={HOME_URL} target="_blank" rel="noopener noreferrer">
                        <img className="site-logo" src="../../assets/images/logo-blue.png" alt="MSP La Pyramide" />
                    </a>
                </Col>
            </Row>

            {status === 'error' ? (
                <StatusComponent message={errorMessage} />
            ) : (
                <StatusComponent />
            )}

            <Row>
                <Col sm={12} className="text-center">
                    <p className="color-green-contact">Pour nous suivre :</p>
                    <div>
                        {SOCIAL_LINKS.map((link) => (
                            <a key={link.alt} href={link.href} target="_blank" rel="noopener noreferrer" className="text-muted m-3">
                                <img src={link.src} alt={link.alt} width="32" />
                            </a>
                        ))}
                    </div>
                </Col>
            </Row>

            <Row>
                <Col sm={12}>
                    <p className="text-center">
                        <small>MSP La Pyramide - 02, Route de Montlhéry - 91200 Athis Mons - Tel secrétariat : 01 69 48 46 78</small>
                    </p>
                    <p className="text-center">
                        <small>Ce message vous est adressé par la MSP La Pyramide. Vous disposez de droits sur vos données personnelles, et notamment d'un droit d'accès, de modification et de suppression de vos données. Vous pouvez exercer vos droits auprès de notre équipe en envoyant un e-mail à admin@msp-la-pyramide.com</small>
                    </p>
                </Col>
            </Row>
        </Container>
    )
}

export default withRouter(CancelSubscription)
